import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography, withStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTriggers } from '../TriggersActions'
import { renderRouteRole } from '../../../../util/utils'
import { Route } from 'react-router-dom/cjs/react-router-dom'
import styles from '../../../../resources/theme/global'
import Filter from './Filter'
import List from './List'
import createEdit from './create-edit'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'

const Triggers = props => {
  const { classes } = props

  const role = useSelector(state => state.auth.role)
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    per_page: 10,
    page: 1,
    reason: '',
    type: '',
  })

  useEffect(() => {
    dispatch(fetchTriggers(form))
  }, [form])

  return (
    <>
      <Grid
        container
        className={classes.pageHead}
        spacing={1}
        alignItems="center"
      >
        <Grid item xs>
          <Typography variant="h4" color="secondary">
            Gatilhos
          </Typography>
        </Grid>
        <Grid item>
          {renderRouteRole(['lavanderia', 'administrador'], role) && (
            <Button
              color="primary"
              variant="contained"
              component={Link}
              to="/crm/triggers/create-edit/new"
            >
              <AddCircleOutlineIcon className={classes.btnIcon} /> Cadastrar
            </Button>
          )}
        </Grid>
        <Grid item>
          <Filter classes={classes} form={form} setForm={setForm} />
        </Grid>
        <Grid item xs={12}>
          <List classes={classes} setForm={setForm} form={form} />
        </Grid>
      </Grid>

      {renderRouteRole(['lavanderia', 'administrador'], role) && (
        <Route path="/crm/triggers/create-edit/:id" component={createEdit} />
      )}
    </>
  )
}

export default withStyles(styles)(Triggers)
